import Swiper, {Navigation} from 'swiper';

const projectAdvantagesSlider = document.querySelector('.j-project-advantages-slider');

if (projectAdvantagesSlider) {
    let slider = {};
    const options = {
        modules          : [Navigation],
        loop             : false,
        speed            : 800,
        spaceBetween     : 0,
        slidesPerView    : 'auto',
        slidesOffsetAfter: 0,
        navigation       : {
            nextEl: '.j-project-advantages-next',
            prevEl: '.j-project-advantages-prev'
        },
        breakpoints: {
            1280: {
                allowTouchMove: false,
                spaceBetween  : 0
            }
        }
    };

    slider = new Swiper(projectAdvantagesSlider, options);
    slider.init();
}

// проверяет количество слайдов в слайдере и скрывает перелистывание на десктопе
if (projectAdvantagesSlider) {
    const sliderItems = projectAdvantagesSlider.querySelectorAll('.project-advantages__slide');
    const sliderControl = document.querySelector('.project-advantages__slider-control');

    if (sliderItems && sliderItems.length < 4 && sliderControl) {
        sliderControl.classList.add('project-advantages__slider-control_display_none');
    }
}
